export enum TimelineTypeEnum {
  OFF_SCHEDULE = -1,
  SERVICE_ORDER = 0,
  ALARM = 1,
  NO_CONTROL = 2,
  ARM = 3,
  DISARM = 4,
  TEST = 5,
  PATROL = 6,
  PANIC = 7,
  COMMAND = 8,
  LOG = 9,
}

export interface Timeline {
  id: number;
  type: TimelineTypeEnum;
  description?: string;
  date: string;

  event?: TimelineEvent;
  logs?: TimelineLog[];
}

export interface PlaceTimeline extends Timeline {
  serviceOrderId?: number;
  observation?: string;
  hasOSImages: boolean;
  hasVTRImages: boolean;
  hasEventImages: boolean;
  text?: string;

  images?: TimelineImage[];
}

export interface SummaryTimeline extends Timeline {
  masterCompanyId: number;
  accountId: number;
  accountCode: string;
  accountName: string;

  command?: Command;
}

export interface Command {
  messageReturn: string;
  commandDescription: string;
  door: string;
  partitionNumber: number;
}

export interface TimelineToPrint
  extends Omit<
      PlaceTimeline | SummaryTimeline,
      'event' | 'hasOSImages' | 'hasVTRImages' | 'hasEventImages' | 'logs' | 'images'
    >,
    Omit<TimelineEvent, 'isOpen'> {
  time: string;
}

export type TimelineEvent = {
  auxiliary?: string;
  code?: string;
  occurrenceId?: string;
  partitionCode?: string;
  partitionDescription?: string;
  isOpen?: boolean;
  observation?: string;
};

export interface TimelineLog {
  date: string;
  id: string;
  text?: string;
}

export interface TimelineImage {
  date: string;
  url: string;
}

export enum TimelineTypeFilterEnum {
  ALL = 0,
  ALARM = 1,
  AUTOMATIC_TEST = 2,
  ARMED = 3,
  DISARMED = 4,
  ARMED_DISARMED = 34,
  WITHOUT_CONTROL = 5,
  PATROL = 6,
}
